import BizminerLayout from "@/bizminer/layouts/app/BizminerLayout.tsx";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card.tsx";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs.tsx";
import { MarkdownContent } from "@/components/MarkdownContent.tsx";

interface Section {
  title: string;
  body: string;
}

interface Group {
  title?: string;
  sections: Section[];
}

interface ShowProps {
  methodology: { groups: Group[] };
  what_it_is: { groups: Group[] };
  product_title: string;
}

function SectionCard({ section }: { section: Section }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{section.title}</CardTitle>
      </CardHeader>
      <CardContent>
        <MarkdownContent content={section.body} />
      </CardContent>
    </Card>
  );
}

function ContentGroups({ groups, layout }: { groups: Group[]; layout: "stack" | "grid" }) {
  return (
    <div className="space-y-6">
      {groups.map((group) => (
        <div key={group.title ?? group.sections[0]?.title}>
          {group.title && (
            <h2 className="text-xl font-semibold text-foreground pt-2 pb-6">{group.title}</h2>
          )}
          <div className={layout === "grid" ? "grid grid-cols-1 md:grid-cols-2 gap-6" : "space-y-6"}>
            {group.sections.map((section) => (
              <SectionCard key={section.title} section={section} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default function Show({ methodology, what_it_is, product_title }: ShowProps) {
  return (
    <BizminerLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-foreground">{product_title}</h1>
          <p className="mt-1 text-muted-foreground">Product documentation and methodology.</p>
        </div>

        <Tabs defaultValue="methodology">
          <TabsList>
            <TabsTrigger value="methodology">Methodology</TabsTrigger>
            <TabsTrigger value="about">About the Index</TabsTrigger>
          </TabsList>
          <TabsContent value="methodology">
            <div className="space-y-6">
              <ContentGroups groups={[methodology.groups[0]]} layout="stack" />
              <ContentGroups groups={[methodology.groups[1]]} layout="grid" />
            </div>
          </TabsContent>
          <TabsContent value="about">
            <ContentGroups groups={what_it_is.groups} layout="grid" />
          </TabsContent>
        </Tabs>
      </div>
    </BizminerLayout>
  );
}
